<div class="select-container" [id]="uniqueId">
    <div class="custom-select" [ngClass]="{'open-dropdown': openDropdown, 'error': error}"
        [style.borderColor]="borderColor" [style.borderRadius]="borderRadius" [style.borderWidth]="borderWidth"
        [style.fontSize]="fontSize" [style.fontWeight]="fontWeight" (click)="toggleDropdown()">
        <div class="span-ellipsis" *ngIf="!loading && !showOtherOptionInput">
            <span *ngIf="translateKey && (selectedKey || selectedKey === 0)">
                {{ translateKey + selectedKey | translate
                }}
            </span>
            <span *ngIf="!translateKey && (selectedKey || selectedKey === 0)">
                {{ selectedKey }}
            </span>
            <span [hidden]="selectedKey || selectedKey === 0" class="placeholder-select">
                {{ placeholder }}
            </span>
        </div>

        <div class="span-ellipsis" *ngIf="showOtherOptionInput && !loading">
            <span>{{otherOptionKey | translate}}</span>
        </div>

        <div class="span-ellipsis" *ngIf="loading">
            <span class="placeholder-select ">
                {{'Loading' | translate}}
            </span>
        </div>

        <div class="chevron" [class.open]="openDropdown"></div>
    </div>
    <div class="options-container" [ngClass]="{'absolute': showAbsolute}" [style.borderColor]="borderColor"
        [style.fontSize]="fontSize" [style.fontWeight]="fontWeight" *ngIf="openDropdown">
        <div class="options-scroll">
            <div *ngFor="let type of dataArray; let last = last">
                <div (click)="selectOption(type)"
                    [ngClass]="(selectedKey !== '' && selectedKey === type) || (showOtherOptionInput && type == otherOptionKey ) ? 'selected-option': 'option'"
                    [attr.aria-selected]="(selectedKey !== '' && selectedKey === type ) || (showOtherOptionInput && type == otherOptionKey )">
                    {{ translateKey + type | translate }}

                    <img *ngIf="(selectedKey !== '' && selectedKey === type ) || (showOtherOptionInput && type == otherOptionKey )"
                        src="../../../../../../../../assets/icons/solid_check.webp" alt="Check Icon" loading="lazy">
                </div>
                <div class="split-option" *ngIf="!last"></div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="otherOption && showOtherOptionInput" class="mg-t15">
    <input id="Mileage" [(ngModel)]="otherOptionText" (ngModelChange)="setOtherOptionText(otherOptionText)"
        class="form-text-input" [placeholder]=" 'Type' | translate" type="text">
</div>